import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, fieldCls } from "@/components/admin/fields";
import { adminApi } from "@/context/AuthContext";
import { LIEUX } from "@/components/site/nav";

// Tells the admin whether the venue is already a place; if not, asks which type the new place gets.
export const NewPlaceCategory = ({ venue, value, onChange }) => {
  const [match, setMatch] = useState(undefined); // undefined = unknown yet, null = new place

  useEffect(() => {
    const v = venue.trim();
    if (!v) { setMatch(undefined); return undefined; }
    const t = setTimeout(async () => {
      try {
        setMatch((await adminApi.get("/admin/places/match", { params: { venue: v } })).data?.match ?? null);
      } catch {
        setMatch(undefined);
      }
    }, 400);
    return () => clearTimeout(t);
  }, [venue]);

  if (match === undefined) return null;
  if (match) {
    return (
      <p className="flex items-center gap-2 text-sm text-zinc-300" data-testid="event-form-place-known">
        <MapPin className="w-4 h-4 text-primary" /> Lieu déjà sur la carte : <strong className="text-white">{match.name}</strong>{match.city ? ` (${match.city})` : ""}
      </p>
    );
  }
  return (
    <Field label="Nouveau lieu : il sera ajouté à la carte comme…">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={fieldCls} data-testid="event-form-place-category"><SelectValue /></SelectTrigger>
        <SelectContent className="rounded-none bg-black border-white/10 z-[200]">
          {LIEUX.map((l) => <SelectItem key={l.key} value={l.key} data-testid={`event-form-place-category-${l.key}`}>{l.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
  );
};
